 document.addEventListener("DOMContentLoaded", function() {
    // Check if the current page is the homepage
    if (window.location.pathname === "/" || window.location.pathname === "/index") {
      // Show the popup and overlay after 3 seconds
      setTimeout(function() {
        const popup = document.getElementById("custom-popup");
        const overlay = document.getElementById("popup-overlay");
        
        if (popup && overlay) {
          popup.style.display = "block";
          overlay.style.display = "block";
        }
      }, 3000);
    }

    // Close the popup and overlay when the close icon is clicked
    const closeIcon = document.getElementById("close-popup");
    if (closeIcon) {
      closeIcon.addEventListener("click", function() {
        const popup = document.getElementById("custom-popup");
        const overlay = document.getElementById("popup-overlay");
        
        if (popup && overlay) {
          popup.style.display = "none";
          overlay.style.display = "none";
        }
      });
    }
  });
